import React from "react";
import {registerBlockType} from "@wordpress/blocks";
import { Fragment } from "@wordpress/element";
import {RichText} from "@wordpress/block-editor";
import IconSelect from "./IconSelect";
import PMGColorPaletete from "./PMGColorPalette";
import {PanelBody,Panel,RangeControl,SelectControl,TextControl,Button, CheckboxControl} from "@wordpress/components";
import {
    useBlockProps,
    ColorPalette,
    InspectorControls,
    InnerBlocks,
    BlockControls,
    AlignmentToolbar,
    MediaUpload,
    MediaUploadCheck
} from '@wordpress/block-editor';

registerBlockType({
  "name":"template-scripts/icon-text-block",
  "title":"Icon Text Block",
  "category":"template-scripts",
  "icon":"button",
  attributes:{
    mainText:{type:'string'},
    styleVersion:{type:'string',default:'default'},
    subText:{type:'string'},
    textAlign:{type:'string',default:'left'},
    icon:{type:'string',default:'diamond-outline'},
    iconColor:{type:'string',default:'#000'},
    svg:{type:'string',default:''},
    headerFontSize:{type:'number',default:24},
    showBorder:{type:'boolean',default:true},
    matchIconColor:{type:'boolean',default:true},
  }
},{
  edit:function({attributes,setAttributes}){
    return (<>
    <InspectorControls>
        <Panel>
          <PanelBody title="Style Version">
            <SelectControl
              value={attributes.styleVersion}
              options={[
                {label:"Default",value:"default"},
                {label:"Full Image",value:"full-image"}
              ]}
              onChange={(v)=>setAttributes({styleVersion:v})}
            />
            </PanelBody>
            <PanelBody title="Icon">
                <IconSelect
                  value={attributes.icon}
                  onChange={(icon)=>{
                    setAttributes({
                      icon:icon.icon,
                      svg:icon.svg
                    });
                  }}
                />
                <PMGColorPaletete
                  value={attributes.iconColor}
                  onChange={(v)=>setAttributes({iconColor:v})}
                />  
                <RangeControl
                  value={attributes.headerFontSize}
                  onChange={(v)=>setAttributes({headerFontSize:v})}
                  min={12}
                  max={60}
                  step={1}
                />
                <CheckboxControl
                  label="Show Border"
                  checked={attributes.showBorder}
                  onChange={(v)=>setAttributes({showBorder:v})}
                />
                <CheckboxControl
                  label="Headline Match Icon Color"
                  checked={attributes.matchIconColor}
                  onChange={(v)=>setAttributes({matchIconColor:v})}
                />
            </PanelBody>
        </Panel>
    </InspectorControls>
      <BlockControls>
        <AlignmentToolbar
            value={ attributes.textAlign }
            onChange={ ( nextAlign ) => {
                setAttributes( { textAlign: nextAlign } );
            } }
        />
      </BlockControls>
      <div className={`iconTextBlock ${attributes.showBorder ? "showBorder" : ""} ${attributes.styleVersion}`} style={{textAlign:attributes.textAlign}}>
            {attributes.svg ? (<div className="svgObject" style={{color:attributes.iconColor}} dangerouslySetInnerHTML={{__html:attributes.svg}}></div>) : (<></>)}
            <RichText style={{fontSize:attributes.headerFontSize+"px",color:attributes.matchIconColor ? attributes.iconColor : "#000"}} tagName="h3" placeholder="Headline" value={attributes.mainText} onChange={(v)=>setAttributes({mainText:v})}/>
            <RichText tagName="p" placeholder="Supporting text..." value={attributes.subText} onChange={(v)=>setAttributes({subText:v})}/>
        </div>
    </>);
  },
  save:function({attributes}){
    return (<div className={`iconTextBlock ${attributes.showBorder ? "showBorder" : ""} ${attributes.styleVersion}`} style={{textAlign:attributes.textAlign}}>
         {attributes.svg ? (<div className="svgObject" style={{color:attributes.iconColor}} dangerouslySetInnerHTML={{__html:attributes.svg}}></div>) : (<></>)}
        <RichText.Content style={{fontSize:attributes.headerFontSize+"px",color:attributes.matchIconColor ? attributes.iconColor : "#000"}} tagName="h3" placeholder="Headline" value={attributes.mainText}/>
        <RichText.Content tagName="p" placeholder="Supporting text..." value={attributes.subText}/>
    </div>);
  }
});
